import { ActionCard } from "./ActionCard";
import { AnalyticsFlowEvent } from "@rapid/analytics/types";
import { useAnalytics } from "@rapid/contexts/AnalyticsContext";
import { useImproveModel } from "@rapid/hooks/useImproveModel";
import { getImproveButtonProps } from "@rapid/hooks/improveButtonProps";
import { TooltipContainer } from "@scripts/react/components/Tooltip";

interface ImproveActionCardProps {
    disabled?: boolean;
}

export const ImproveActionCard = ({ disabled = false }: ImproveActionCardProps) => {
    const { track } = useAnalytics();
    const { handleImprove, loading } = useImproveModel();

    const isDisabled = disabled || loading;
    const { title, description, icon } = getImproveButtonProps(false, loading);

    const handleClick = () => {
        track({ event: AnalyticsFlowEvent.IMPROVE_MODEL_CLICKED, data: { step: "review" } });
        handleImprove();
    };

    return (
        <TooltipContainer
            type="titleOnly"
            title="Publish your model first to collect training data."
            placement="left"
            disabled={isDisabled}
            customButton={
                <div>
                    <ActionCard
                        title={title}
                        description={description}
                        icon={icon}
                        type="primary"
                        onClick={isDisabled ? undefined : handleClick}
                        disabled={isDisabled}
                    />
                </div>
            }
        />
    );
};
